import { useEffect } from 'react';
import { useState } from 'react';
import './Addcatetegery.css';
import { useParams } from 'react-router-dom';

import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const Edittotal = ()=>{
    const [sum, setSum] = useState('');
    const [sum_id, setSum_id] = useState(0);
 //   const [wdetails_id, setWdetails_id] = useState(0);
    let navigt = useNavigate();
    let  { bandId }  =useParams();



    const  formSubmit = (e)=>{
            e.preventDefault()
            axios.post(`https://backend.dasta.net/api/auth/updatedesum/${bandId}`,{
                sum_id,
                sum,
               // wdetails_id,

            }).then((data)=>{
                navigt(-1);
            })
        }  

    return (
        
        <>
        <form onSubmit={formSubmit}>
            <label for="lname">Price:</label>
            <input type="text" id="lname" name="lname"  onChange={(e)=>setSum(e.target.value)}/>            
            <button type='submit' >Update</button>
        </form> 


        </>

    )
}
export default Edittotal;